import { defineStore } from "pinia"
import { SettingService } from "@/store/services/setting.service.js"
import { storeToRefs } from "pinia"

export const settingStore = defineStore("setting", {
  state: () => {
    return {
      settings: "",
    }
  },
  getters: {
    getSettings: (state) => state.settings,
  },
  actions: {
    getSettingsAction() {
      if (this.settings != "") return this.settings
      EventSys.$emit("settings_loading")

      SettingService.list().then(({ data }) => {
        EventSys.$emit("settings_loaded")
        this.settings = data
        return this.settings
      })
    },
    getSetting(key) {
      if (this.settings != "") return this.settings[key]
      EventSys.$emit("settings_loading")
      SettingService.list().then(({ data }) => {
        EventSys.$emit("settings_loaded")
        this.settings = data
        return this.settings[key]
      })
    },
  },
})
